import createReactComponent from "../createReactComponent";
import defaultAttributes from "../defaultAttributes";
var MousePointer = createReactComponent("MousePointer", ["svg", defaultAttributes, [["path", {
  d: "M3 3l7.07 16.97 2.51-7.39 7.39-2.51L3 3z",
  key: "13etbm"
}], ["path", {
  d: "M13 13l6 6",
  key: "fs9n40"
}]]]);
export default MousePointer;